__turbopack_context__.v({
  "Item": "ZI_Zeq_Item",
  "Item--IsActive": "ZI_Zeq_Item--IsActive",
  "Link": "ZI_Zeq_Link",
  "List": "ZI_Zeq_List",
  "MobileDropdown": "ZI_Zeq_MobileDropdown",
  "MobileDropdownLabel": "ZI_Zeq_MobileDropdownLabel",
  "Root": "ZI_Zeq_Root",
  "Root--IsOpen": "ZI_Zeq_Root--IsOpen",
  "skeleton-loading": "ZI_Zeq_skeleton-loading",
});
